export default "__VITE_ASSET__DGmf_Ph4__"